<template>
  <div
    class="tw-flex tw-max-w-[800px] tw-flex-col tw-justify-center tw-items-start tw-gap-[25px] tw-self-stretch tw-px-0 tw-py-[25px] tw-rounded-[6px] mainWrapper"
  >
    <div
      :style="{
        paddingLeft: customPaddingX,
        paddingRight: customPaddingX,
      }"
      class="tw-flex tw-flex-col tw-gap-[10px] main"
    >
      <div class="tw-flex tw-gap-[10px] tw-items-center titleWrapper">
        <span
          class="tw-text-[#211F58] tw-text-[15px] tw-not-italic tw-font-medium tw-leading-[145%] title"
        >
          {{ title }}
        </span>
      </div>
      <div class="descriptionWrapper">
        <span
          class="tw-text-[#878787] tw-text-[13px] tw-not-italic tw-font-[400] tw-leading-[normal] description"
          >{{ description }}</span
        >
        <span>{{ " " }}</span>
        <span
          v-if="hasWhy"
          class="tw-text-[#387DFF] tw-text-[13px] tw-not-italic tw-font-[500] tw-leading-[normal] tw-cursor-pointer hover:tw-opacity-80"
          @click="openModalMoreInfor"
        >
          {{
            getComponentUiText(
              "app-menu-submenu-home-setup-wizard-modal-wrapper-description-why-link-1",
            )
          }}
        </span>
      </div>
    </div>
    <span class="tw-h-[1px] tw-w-full tw-bg-[#EFF0F1]" />
    <div
      :style="{
        paddingLeft: customPaddingX,
        paddingRight: customPaddingX,
      }"
      class="tw-w-full questionsWrapper"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { IModalMessage } from "@/interfaces/common/common";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { MODAL_NAME } from "@/utils/constants";
import { getComponentUiText } from "@/utils/utilities";

defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: "",
  },
  hasWhy: {
    type: Boolean,
    default: false,
  },
  customPaddingX: {
    type: String,
    default: "25px",
  },
});

const openModalMoreInfor = () => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_WIZARD_MORE_INFO,
    properties: {
      isMoreInfoModal: true,
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};
</script>

<style scoped>
.mainWrapper {
  border: 1px solid #eff0f1;
  background: #ffffff;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
}
</style>
